import React from "react";
import { Redirect } from "react-router-dom";

// // Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

import ForgetPwd from "../pages/Authentication/ForgetPassword";
import AllUsers from "../admin/users/index";
// Admin Dashboard
import AdminDashboard from "../admin/dashboard/index";
import AdminChangePassword from "../admin/account/index";
import Commission from "../admin/Commission/index";
import ResetPassword from "pages/Authentication/ResetPassword";
import Faq from "../admin/faq/Faq"
import Airdrop from "../admin/airdrop"
import Plans from "../admin/plans/plans"
import Stacking from "../admin/Stacking/stacking"
import category from "admin/category/category";

const authProtectedRoutes = [
  // Admin Routes
  { path: "/admin/dashboard", component: AdminDashboard },
  { path: "/admin/profile", component: AdminChangePassword },
  { path: "/admin/commission", component: Commission },
  { path: "/admin/all-users", component: AllUsers },
  { path: "/admin/airdrop", component: Airdrop },
  { path: "/admin/faqs", component: Faq},
  { path: "/admin/plans", component: Plans},
  {path: "/admin/stacking", component: Stacking},
  { path: "/admin/category", component: category},
  { path: "/dashboard", component: AdminDashboard },
  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/reset-password", component: ResetPassword },
  // { path: "/register", component: Register },
];

export { authProtectedRoutes, publicRoutes };
